import styled from "styled-components"
import {Fragment} from "react"
import {useParams} from "react-router-dom"
import {useFindGroupMembers} from "hooks/query/group-query"

export function UpdateGroupMembers() {
    const {id} = useParams<{ id: string }>()
    const {data: members} = useFindGroupMembers(id)
    console.log("members : ", members)
    return (
        <Fragment>
            <Header className="flex flex-row mt-7 pb-3">
                <div className="basis-1/6">사용자 ID</div>
                <div className="basis-1/6">성</div>
                <div className="basis-1/6">이름</div>
                <div className="basis-2/6">이메일</div>
                <div className="basis-1/6">Link</div>
            </Header>
            {members?.map(member => {
                const {username, firstName, lastName, email } = member
                return (
                    <Body className="flex flex-row">
                        <Item className="basis-1/6">{username}</Item>
                        <Item className="basis-1/6">{firstName}</Item>
                        <Item className="basis-1/6">{lastName}</Item>
                        <Item className="basis-2/6">{email}</Item>
                        <Item className="basis-1/6">
                            <button className="button is-link is-small mt-3">보기</button>
                        </Item>
                    </Body>
                )
            })}

        </Fragment>
    )
}

const Header = styled.div`
  vertical-align: middle;
  text-align: center;
  color: #a0aec0;
  font-size: .75rem;
  border: 0;
  background: #fff;
  border-bottom: 1px #E2E8F0 solid;
`

const Body = styled.div`
  vertical-align: middle;
  color: #666;
  font-size: 0.9rem;
  text-align: center !important;
  border-bottom: 1px solid #E2E8F0;
`

const Item = styled.div`
  text-align: center;
  line-height: 45px;
  min-height: 45px;
  font-weight: 400;
  vertical-align: middle;
  padding: 2px;
`